import { activityLogsApiClient } from '../apiClients';

export const logPageView = async (eventData: any) => {
  try {
    activityLogsApiClient.post('/', eventData).catch((error) => {
      console.error('Error logging to API:', error);
    });

    if (typeof window !== 'undefined' && window.posthog?.capture) {
      window.posthog.capture(eventData.event, eventData);
    }
  } catch (error) {
    console.error('Error logging event to PostHog or backend:', error);
  }
};
